<div class="metadata-tab" *ngIf="metadata">
  <!-- Destination: All + destinations checked on Destinations tab -->
  <div class="metadata-tab__section">
    <div class="metadata-tab__label-row">
      <label class="metadata-tab__label">Destination</label>
      <span
        *ngIf="hasAnyDestinationOverride"
        class="metadata-tab__override-badge"
        >OVERRIDE</span
      >
      <a
        *ngIf="hasAnyDestinationOverride"
        href="javascript:void(0)"
        class="metadata-tab__reset-link"
        (click)="resetDestinationMetadataToShared()"
        >Reset to shared</a
      >
    </div>
    <evrideo-clipping-studio-destination-picker
      [selectedDestinationId]="selectedDestinationId"
      (selectedDestinationIdChange)="onDestinationChange($event)"
    ></evrideo-clipping-studio-destination-picker>
  </div>

  <!-- Clip Title -->
  <div class="metadata-tab__section">
    <div class="metadata-tab__label-row">
      <div class="metadata-tab__label-row-main">
        <label class="metadata-tab__label">Clip Title</label>
        <span
          *ngIf="isModified(effectiveTitle, initialDefaults.title)"
          class="metadata-tab__modified"
          >MODIFIED</span
        >
        <span *ngIf="hasTitleOverride" class="metadata-tab__override"
          >OVERRIDE</span
        >
      </div>
      <span
        class="metadata-tab__char-count"
        [class.metadata-tab__char-count--error]="titleLimitExceeded"
      >
        {{ titleCharacterCount }}/{{ titleMaxLength }}
      </span>
    </div>
    <input
      type="text"
      class="metadata-tab__input"
      [class.metadata-tab__input--modified]="
        isModified(effectiveTitle, initialDefaults.title)
      "
      [ngModel]="effectiveTitle"
      (ngModelChange)="setEffectiveTitle($event)"
    />
  </div>

  <!-- Tags -->
  <div class="metadata-tab__section">
    <div class="metadata-tab__label-row">
      <label class="metadata-tab__label">Tags</label>
      <span
        *ngIf="isModified(effectiveTags, initialDefaults.tags)"
        class="metadata-tab__modified"
        >MODIFIED</span
      >
      <span *ngIf="hasTagsOverride" class="metadata-tab__override"
        >OVERRIDE</span
      >
    </div>
    <input
      type="text"
      class="metadata-tab__input"
      [class.metadata-tab__input--modified]="
        isModified(effectiveTags, initialDefaults.tags)
      "
      [ngModel]="effectiveTags"
      (ngModelChange)="setEffectiveTags($event)"
      placeholder="Add keywords..."
    />
  </div>

  <!-- Message -->
  <div class="metadata-tab__section">
    <div class="metadata-tab__label-row">
      <label class="metadata-tab__label">Message (Social Post)</label>
      <span
        *ngIf="isModified(effectiveMessage, initialDefaults.message)"
        class="metadata-tab__modified"
        >MODIFIED</span
      >
      <span *ngIf="hasMessageOverride" class="metadata-tab__override"
        >OVERRIDE</span
      >
    </div>
    <textarea
      class="metadata-tab__textarea"
      [class.metadata-tab__input--modified]="
        isModified(effectiveMessage, initialDefaults.message)
      "
      [ngModel]="effectiveMessage"
      (ngModelChange)="setEffectiveMessage($event)"
      rows="3"
    ></textarea>
  </div>

  <button
    type="button"
    class="metadata-tab__btn metadata-tab__btn--ai"
    [disabled]="isAICompleting || !canRunAiMetadata"
    (click)="triggerAiComplete()"
  >
    <ng-container *ngIf="isAICompleting; else aiCompleteIdle">
      <span class="metadata-tab__spinner"></span>
      AI Analysing...
    </ng-container>
    <ng-template #aiCompleteIdle>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
      </svg>
      AI Auto-Complete
    </ng-template>
  </button>

  <div class="metadata-tab__spacer"></div>
</div>
